// src/components/ProductReviewForm.js
import React, { useState } from 'react';

const bs = { fontFamily: "'Montserrat', sans-serif" };

const ProductReviewForm = ({ productId, onSubmit }) => {
  const [rating,       setRating]       = useState(0);
  const [hover,        setHover]        = useState(0);
  const [comment,      setComment]      = useState('');
  const [reviewerName, setReviewerName] = useState('');
  const [submitting,   setSubmitting]   = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!rating || !comment.trim() || !reviewerName.trim()) {
      alert('Por favor completa todos los campos.');
      return;
    }
    setSubmitting(true);
    await onSubmit({ productId, rating, comment, reviewerName, date: new Date().toISOString() });
    setRating(0); setComment(''); setReviewerName('');
    setSubmitting(false);
  };

  const inputStyle = {
    ...bs, width: '100%', padding: '10px 12px',
    border: '1px solid #e5e0e0', background: 'white',
    fontSize: '13px', color: '#060D14', outline: 'none',
    borderRadius: '1px', boxSizing: 'border-box',
    transition: 'border-color 0.2s',
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
      <div>
        <label style={{ ...bs, display: 'block', fontSize: '10px', letterSpacing: '0.2em',
          textTransform: 'uppercase', color: '#999', marginBottom: '6px' }}>Tu nombre</label>
        <input type="text" value={reviewerName} onChange={e => setReviewerName(e.target.value)}
          style={inputStyle}
          onFocus={e => e.target.style.borderColor = '#961914'}
          onBlur={e => e.target.style.borderColor = '#e5e0e0'}
          required />
      </div>

      <div>
        <label style={{ ...bs, display: 'block', fontSize: '10px', letterSpacing: '0.2em',
          textTransform: 'uppercase', color: '#999', marginBottom: '6px' }}>Calificación</label>
        <div style={{ display: 'flex', gap: '4px' }}>
          {[1,2,3,4,5].map(s => (
            <button key={s} type="button"
              onClick={() => setRating(s)}
              onMouseEnter={() => setHover(s)}
              onMouseLeave={() => setHover(0)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px',
                transition: 'transform 0.15s' }}
              onMouseOver={e => e.currentTarget.style.transform = 'scale(1.15)'}
              onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}>
              <svg width="24" height="24" fill="currentColor" viewBox="0 0 20 20"
                style={{ color: s <= (hover || rating) ? '#f59e0b' : '#e5e7eb' }}>
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.92 8.725c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z"/>
              </svg>
            </button>
          ))}
        </div>
      </div>

      <div>
        <label style={{ ...bs, display: 'block', fontSize: '10px', letterSpacing: '0.2em',
          textTransform: 'uppercase', color: '#999', marginBottom: '6px' }}>Comentario</label>
        <textarea value={comment} onChange={e => setComment(e.target.value)} rows={3}
          style={{ ...inputStyle, resize: 'none' }}
          onFocus={e => e.target.style.borderColor = '#961914'}
          onBlur={e => e.target.style.borderColor = '#e5e0e0'}
          required />
      </div>

      <button type="submit" disabled={submitting} style={{
        ...bs, padding: '12px', background: '#961914', color: 'white',
        border: 'none', cursor: submitting ? 'not-allowed' : 'pointer',
        fontSize: '10px', fontWeight: 600, letterSpacing: '0.18em',
        textTransform: 'uppercase', borderRadius: '1px',
        opacity: submitting ? 0.6 : 1, transition: 'background 0.2s',
      }}
      onMouseOver={e => { if (!submitting) e.currentTarget.style.background = '#7a140f'; }}
      onMouseOut={e => e.currentTarget.style.background = '#961914'}>
        {submitting ? 'Enviando…' : 'Enviar Reseña'}
      </button>
    </form>
  );
};

export default ProductReviewForm;
